import Http from '~fdp/core/network/http.js'

import { forEach, pick, toUpper } from 'lodash'
import NrwApis from '@/config/router/nrw/apiMain.js'

const mmpAxiosWrapperPlugin = {
  install: function (Vue) {
    var httpInject = {
    }

    forEach(window.vue.config.http, (val, key) => {
      let httpConfig = pick(val, ['baseURI', 'proxy'])
      // console.log(httpConfig)

      let httpObj = new Http(httpConfig)

      let axios = httpObj.axios

      httpInject[key] = httpObj

      httpInject[key].setCommonHeader(axios)
      httpInject[key].setInterceptor(axios)

      if (key === 'b2c') {
        window.vue.config.http.b2c.apiPath = Object.assign(window.vue.config.http.b2c.apiPath, NrwApis)
      }

      forEach(val.apiPath, (apiObj, apiKey) => {
        httpInject[key][apiKey] = (context, params, header) => {
          if (toUpper(apiObj.method) === 'POST') {
            if (apiObj.upload === true) {
              return httpInject[key].upload(context, apiObj, params, header)
            } else {
              return httpInject[key].post(context, apiObj, params, header)
            }
          } else if (toUpper(apiObj.method) === 'GET') {
            return httpInject[key].get(context, apiObj, params, header)
          }
        }
        httpInject[key][apiKey + 'Url'] = apiObj.url
      })

      if (key === 'mmp') {
        httpInject.axios = axios
        httpInject.loadRes = httpObj.loadRes
        httpInject.upload = httpObj.upload
      }
    })
    window.vue.setInstance('http', httpInject)
    Vue.http = Vue.prototype.$http = httpInject
  }
}

export default mmpAxiosWrapperPlugin



// WEBPACK FOOTER //
// ./src/plugins/_common/MmpResource.js